import React, { useLayoutEffect } from 'react';

import { usePeriodPickerQueries } from '@entities/period-picker/lib/usePeriodPickerQueries';
import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';
import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { TCalendarRange } from '@features/CalendarPeriodPicker/model/types';
import { DateHelpers } from '@shared/helpers';

interface IUseSetCalendarRangeInFirstRenderProps {
    setCalendarRange: React.Dispatch<React.SetStateAction<TCalendarRange>>;
}

export const useSetCalendarRangeInFirstRender = ({
    setCalendarRange,
}: IUseSetCalendarRangeInFirstRenderProps) => {
    const { getPreviousSevenDays, dateFormatter } = DateHelpers;
    const currentPickerId = PickerTitle.PREVIOUS_SEVEN_DAYS;
    // const { setState } = useNuqsQueryState(PERIOD_PICKER_QUERY);
    const { setPeriodPickerQueryValue } = usePeriodPickerQueries();
    const { setDateFromQueryValue, setDateToQueryValue } = useCalendarQueries();

    useLayoutEffect(() => {
        if (currentPickerId === PickerTitle.PREVIOUS_SEVEN_DAYS) {
            setCalendarRange(getPreviousSevenDays());
            void setPeriodPickerQueryValue(PickerTitle.PREVIOUS_SEVEN_DAYS);
            const [start, end] = getPreviousSevenDays();
            void setDateFromQueryValue(dateFormatter({ date: start }));
            void setDateToQueryValue(dateFormatter({ date: end }));
        }
    }, [
        currentPickerId,
        setCalendarRange,
        setPeriodPickerQueryValue,
        getPreviousSevenDays,
        dateFormatter,
        setDateFromQueryValue,
        setDateToQueryValue,
    ]);

    return {
        currentPickerId,
    };
};
